import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { DashboardLayout } from '@/components/DashboardLayout';
import { Login } from '@/pages/Login';
import { Register } from '@/pages/Register';
import { ForgotPassword, ResetPassword } from '@/pages/PasswordReset';
import { Dashboard } from '@/pages/Dashboard';
import { CRM } from '@/pages/CRM';
import { Documents } from '@/pages/Documents';
import { Compliance } from '@/pages/Compliance';
import { Invoices } from '@/pages/Invoices';
import { Bookkeeping } from '@/pages/Bookkeeping';
import { Tasks } from '@/pages/Tasks';
import { Settings } from '@/pages/Settings';
import { Suppliers } from '@/pages/Suppliers';
import { PurchaseOrders } from '@/pages/PurchaseOrders';
import { POPs } from '@/pages/POPs';
import { BankStatements } from '@/pages/BankStatements';
import { Anomalies } from '@/pages/Anomalies';
import { AuditLogs } from '@/pages/AuditLogs';
import { Templates } from '@/pages/Templates';
import { AIAssist } from '@/pages/AIAssist';
import Landing, { FloatingEmail } from '@/pages/Landing';
import Pricing from '@/pages/Pricing';
import Consultation from '@/pages/Consultation';
import { Billing } from '@/pages/Billing';
import BillingCallback from '@/pages/BillingCallback';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

const PUBLIC_PATHS = ['/', '/pricing', '/consultation'];

function PublicFloatingEmail() {
  const location = useLocation();
  if (!PUBLIC_PATHS.includes(location.pathname)) return null;
  return <FloatingEmail />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public marketing routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/consultation" element={<Consultation />} />

          {/* Auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected app routes */}
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/ai-assist" element={<AIAssist />} />
            <Route path="/crm" element={<CRM />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/purchase-orders" element={<PurchaseOrders />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/pops" element={<POPs />} />
            <Route path="/bank-statements" element={<BankStatements />} />
            <Route path="/bookkeeping" element={<Bookkeeping />} />
            <Route path="/anomalies" element={<Anomalies />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/billing/callback" element={<BillingCallback />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <PublicFloatingEmail />
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
